import React, { useState, useEffect } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { get } from 'global/lib/lodash';
import { stopProp } from '../../utils';

export default (props) => {
  const { open, currentIndex, images } = props;

  const [photoIndex, setPhotoIndex] = useState(!currentIndex ? 0 : currentIndex);

  const onClose = (e) => {
    const close = get(props, 'onClose', () => 0);
    close();
  };

  const onPhoto = (ind) => {
    props.onPhoto && props.onPhoto(images[ind]);
  };

  useEffect(() => {
    if (open) {
      onPhoto(currentIndex);
    }
  }, [open]);

  const onMoveNext = (e, dir) => {
    setPhotoIndex(dir);
    onPhoto(dir);
  };

  useEffect(() => {
    if (currentIndex !== undefined) {
      setPhotoIndex(currentIndex);
    }
  }, [currentIndex]);

  const isOpen = !!open;

  return (
    <>
      {isOpen && (
        <div onClick={(e) => stopProp(e)}>
          <Lightbox
            {...props}
            mainSrc={get(images, [photoIndex, 'src'])}
            nextSrc={get(images, [(photoIndex + 1) % images.length, 'src'])}
            prevSrc={get(images, [(photoIndex + images.length - 1) % images.length, 'src'])}
            imageCaption={get(images, [photoIndex, 'caption'])}
            onCloseRequest={onClose}
            onMovePrevRequest={(e) => onMoveNext(e, (photoIndex + images.length - 1) % images.length)}
            onMoveNextRequest={(e) => onMoveNext(e, (photoIndex + 1) % images.length)}
            onImageLoadError={(e) => console.error(e.message)}
          />
        </div>
      )}
    </>
  );
};
